import { motion } from "framer-motion";
import { Check, Zap } from "lucide-react";
import { PACKAGES } from "@/data";
import { useStore } from "@/context/StoreContext";

export const Packages = () => {
  const { setBookingTier } = useStore();

  return (
    <section id="packages" data-testid="packages-section" className="relative py-24 sm:py-32 bg-cosmic-elevated/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-cosmic-pink">Live Event Spinning</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            Bring the <span className="text-gradient-candy">galaxy</span> to your event
          </h2>
          <p className="mt-4 text-base text-slate-400 leading-relaxed">
            We roll up with the machine, the sugar, and the show. Every package includes
            <span className="text-white font-semibold"> unlimited cones</span> spun live for your guests.
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2 xl:grid-cols-4" data-testid="packages-grid">
          {PACKAGES.map((tier, i) => (
            <motion.div
              key={tier.tier_id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className={`relative rounded-3xl p-[1.5px] ${tier.popular ? "bg-gradient-to-b from-cosmic-pink via-cosmic-purple to-cosmic-cyan" : "bg-white/10"}`}
              data-testid={`package-card-${tier.tier_id}`}>
              {tier.popular && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 z-10 flex items-center gap-1.5 rounded-full bg-gradient-to-r from-cosmic-pink to-cosmic-purple px-4 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.16em] text-white glow-pink">
                  <Zap size={11} /> Most Popular
                </span>
              )}
              <div className="flex h-full flex-col rounded-3xl bg-cosmic-elevated p-6">
                <h3 className="font-display text-xl font-bold text-white">{tier.name}</h3>
                <div className="mt-3 flex items-end gap-1.5">
                  <span className="font-display text-4xl font-black text-white">${tier.price}</span>
                  <span className="pb-1 text-sm text-slate-400">/ {tier.duration_hours} hr{tier.duration_hours > 1 ? "s" : ""}</span>
                </div>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{tier.description}</p>
                <ul className="mt-5 flex-1 space-y-2.5">
                  {tier.included.map((inc) => (
                    <li key={inc} className="flex items-start gap-2.5 text-sm text-slate-300">
                      <Check size={15} className="mt-0.5 shrink-0 text-cosmic-cyan" />
                      {inc}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`book-${tier.tier_id}-button`}
                  onClick={() => setBookingTier(tier)}
                  className={`mt-6 w-full rounded-full py-3 text-sm font-bold transition-transform duration-300 hover:scale-[1.04] ${
                    tier.popular
                      ? "bg-gradient-to-r from-cosmic-pink to-cosmic-purple text-white glow-pink"
                      : "glass text-white hover:border-cosmic-cyan/50"}`}>
                  Book {tier.name.split(" ")[0]}
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;
